var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import axios from 'axios';
import qs from 'qs';
var HttpError = /** @class */ (function (_super) {
    __extends(HttpError, _super);
    function HttpError(message, status, serverError) {
        var _this = _super.call(this, message) || this;
        _this.status = status;
        _this.serverError = serverError;
        return _this;
    }
    return HttpError;
}(Error));
export { HttpError };
var HttpService = /** @class */ (function () {
    function HttpService() {
    }
    HttpService.prototype.get = function (url, query) {
        return __awaiter(this, void 0, void 0, function () {
            var headers, token, result, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        headers = {};
                        token = localStorage.getItem('jwt');
                        if (token) {
                            headers.Authorization = "Bearer " + token;
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, axios.get("" + process.env.REACT_APP_API_URL + url, {
                                params: query,
                                paramsSerializer: function (q) { return qs.stringify(q, {
                                    skipNulls: true,
                                    indices: true,
                                    encode: false
                                }); },
                                headers: headers
                            })];
                    case 2:
                        result = _a.sent();
                        return [2 /*return*/, result.data];
                    case 3:
                        error_1 = _a.sent();
                        // TODO: Network error
                        throw new HttpError(error_1.message, error_1.response.status, error_1.response.data);
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    HttpService.prototype.post = function (url, body, query) {
        return __awaiter(this, void 0, void 0, function () {
            var headers, token, result, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        headers = {};
                        token = localStorage.getItem('jwt');
                        if (token) {
                            headers.Authorization = "Bearer " + token;
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, axios.post("" + process.env.REACT_APP_API_URL + url, body, {
                                params: query,
                                headers: headers
                            })];
                    case 2:
                        result = _a.sent();
                        return [2 /*return*/, result.data];
                    case 3:
                        error_2 = _a.sent();
                        // TODO: Network error
                        throw new HttpError(error_2.message, error_2.response.status, error_2.response.data);
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    HttpService.prototype.patch = function (url, body, query) {
        return __awaiter(this, void 0, void 0, function () {
            var headers, token, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        headers = {};
                        token = localStorage.getItem('jwt');
                        if (token) {
                            headers.Authorization = "Bearer " + token;
                        }
                        return [4 /*yield*/, axios.patch("" + process.env.REACT_APP_API_URL + url, body, {
                                params: query,
                                headers: headers
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.data];
                }
            });
        });
    };
    HttpService.prototype.delete = function (url, query) {
        return __awaiter(this, void 0, void 0, function () {
            var headers, token, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        headers = {};
                        token = localStorage.getItem('jwt');
                        if (token) {
                            headers.Authorization = "Bearer " + token;
                        }
                        return [4 /*yield*/, axios.delete("" + process.env.REACT_APP_API_URL + url, {
                                params: query,
                                headers: headers
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.data];
                }
            });
        });
    };
    return HttpService;
}());
export { HttpService };
//# sourceMappingURL=http.service.js.map